import React from 'react';
import SettingsModal from 'appToolbar/SettingsModal';
import './WidgetToolbar.scss';
import { ToolbarIconWithText } from '@instinet-analytics/semantic-ui-components';
import { doNothing } from 'utils/general';

export type OnSaveHandler = () => void | {
    cancel: boolean;
};
export interface WidgetSettingsButtonProps {
    triggerText?: string;
    header?: string;
    body?: JSX.Element;
    className?: string;
    saveText?: string;
    allowCancel?: boolean;
    onSave?: OnSaveHandler;
}

export default function WidgetSettingsButton(props: WidgetSettingsButtonProps) {
    const {
        triggerText,
        header,
        body,
        className,
        allowCancel,
        onSave: onSaveProps,
        saveText,
    } = props;

    const onSave = onSaveProps || doNothing;

    return (
        <SettingsModal
            className={className}
            trigger={
                <ToolbarIconWithText
                    name="cog"
                    className="settings-button"
                    tooltip={{
                        body: triggerText || 'Chart Configuration',
                    }}
                    text={triggerText || 'Chart Configuration'}
                />
            }
            headerText={header || 'Settings'}
            saveText={saveText || 'Close'}
            allowCancel={allowCancel}
            cancelText={'Cancel'}
            onOpen={() => {
                return;
            }}
            onSave={onSave}
        >
            {body}
        </SettingsModal>
    );
}
